<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	firstColumnProperty="property.name"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="propertyName"
				[defaultFilterLabel]="fieldLabels.propertyName"
				[placeholder]="fieldLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.propertyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('propertyName')"
								(ngModelChange)="dataSet.filter('propertyName', fieldLabels.propertyName, $event)"
								data-automation-id="property-name-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.address }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('address')"
								(ngModelChange)="dataSet.filter('address', fieldLabels.address, $event)"
								data-automation-id="address-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Make this work -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.postalCode }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('postalCode')"
								(ngModelChange)="dataSet.filter('postalCode', fieldLabels.postalCode, $event)"
								data-automation-id="postal-code-input"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="2">
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Should use country code dropdown -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.country }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('countryCode')"
								(ngModelChange)="dataSet.filter('countryCode', fieldLabels.country, $event)"
								data-automation-id="country-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.status }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('active')"
								(ngModelChange)="dataSet.filter('active', fieldLabels.status, $event, activeOptions)"
								data-automation-id="status-picker"
							>
								@for (option of activeOptions; track option.value) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.value">
										{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (canAddProperty) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@property-listAdd"
					(click)="onAddButtonClick()"
					data-automation-id="add-company-button"
				></app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getCompanyPropertiesByCompanyIdLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getCompanyPropertiesByCompanyIdLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@property-listName">Name</th>
					<td mat-cell *matCellDef="let row">{{ row.property.name }}</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyListTable-address2">Address</th>
					<td mat-cell *matCellDef="let row">
						<div [innerHtml]="row.property.address | address"></div>
					</td>
				</ng-container>

				<ng-container matColumnDef="devices">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@property-listDevices">Devices</th>
					<td mat-cell *matCellDef="let row">{{ row.deviceCount }}</td>
				</ng-container>

				<ng-container matColumnDef="active">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@property-listStatus">Status</th>
					<td mat-cell *matCellDef="let row">
						@if (row.property.active) {
							<span i18n="@@propertyListTable-active">Active</span>
						}
						@if (!row.property.active) {
							<span i18n="@@propertyListTable-inactive">Inactive</span>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
					<td mat-cell *matCellDef="let row">{{ row.name }}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row.property)"
					[attr.data-automation-id]="'property-' + row.id + '-row'"
				></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
